import React from 'react';
import { ProcedureType } from '../../../../services/ConfigurationService/types/procedureType';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem } from '@mui/material';
import { useUpsertProcedureMutation, useGetProcedureTypesQuery } from '../../../../services/ConfigurationService';

export function EditProcedureDialog({ procedure, onCancel, onSuccess }: {
  procedure: ProcedureType;
  onCancel: () => void;
  onSuccess?: (p: ProcedureType) => void;
}) {
  const [code, setCode] = React.useState(procedure.code);
  const [description, setDescription] = React.useState(procedure.description);
  const [codeType, setCodeType] = React.useState(procedure.codeType ? procedure.codeType : 'CPT');
  const [upsertProcedure, { isLoading }] = useUpsertProcedureMutation();
  const { data: procedureTypes = [] } = useGetProcedureTypesQuery();

  const handleSave = async () => {
    const id = `${procedure.centerId}-${code}`;
    const updatedProcedure: ProcedureType = { ...procedure, code, description, codeType: codeType ? codeType : 'CPT', id };
    await upsertProcedure(updatedProcedure);
    if (onSuccess) onSuccess(updatedProcedure);
    onCancel();
  };

  return (
    <Dialog open onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Procedure</DialogTitle>
      <DialogContent>
        <TextField
          label="Code"
          value={code}
          onChange={e => setCode(e.target.value)}
          fullWidth
          margin="normal"
          disabled
        />
        <TextField
          label="Description"
          value={description}
          onChange={e => setDescription(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          select
          label="Code Type"
          value={codeType}
          onChange={e => setCodeType(e.target.value)}
          fullWidth
          margin="normal"
        >
          {procedureTypes.map(option => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={isLoading}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}


